import {
  Box, List, makeStyles, Typography,
} from '@material-ui/core';
import React from 'react';
import { FLASHY_PLAYER_BLUE } from '../constants';
import { ListItemLink } from './ListItemLink';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: '3vw',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingBottom: theme.spacing(1),
    borderBottom: `solid ${theme.palette.divider} 1px`,
    flexWrap: 'wrap',
  },
  titleAndBetaContainer: {
    display: 'flex',
  },
  title: {
    color: FLASHY_PLAYER_BLUE,
    fontSize: '3em',
    [theme.breakpoints.down('xs')]: {
      fontSize: '2em',
    },
  },
  beta: {
    color: '#1A76BC',
    fontWeight: 'bold',
    fontSize: '1.5em',
    marginLeft: theme.spacing(1),
  },
  menuNav: {
  },
  menuList: {
    padding: 0,
    display: 'flex',
    flexWrap: 'wrap',
  },
  menuItem: {
    width: 'auto',
    whiteSpace: 'nowrap',
    padding: theme.spacing(1),
  },
  menuItemHighlight: {
    color: theme.palette.primary.main,
  },
}));

export const Header = (): JSX.Element => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <div className={classes.titleAndBetaContainer}>
        <Typography variant="h2" component="h1" className={classes.title}>
          FlashyPlayer
        </Typography>
        <Typography component="div" className={classes.beta}>
          BETA
        </Typography>
      </div>
      <nav className={classes.menuNav}>
        <List className={classes.menuList}>
          <ListItemLink className={classes.menuItem} href="/">
            Home
          </ListItemLink>
          <ListItemLink className={classes.menuItem} href="/screenshots">
            Screenshots
          </ListItemLink>
          <ListItemLink className={classes.menuItem} href="/troubleshooting">
            Troubleshooting
          </ListItemLink>
          <ListItemLink className={classes.menuItem} href="/contact">
            Contact
          </ListItemLink>
          <ListItemLink className={classes.menuItem} href="/about">
            About
          </ListItemLink>
        </List>
      </nav>
    </Box>
  );
};
